import { SplitFactory } from "@splitsoftware/splitio";
import { setFeatureFlags } from "../store/reducers/split";
import { decrypt } from ".";
import { REACT_APP_SPLIT_KEY_ENC } from "../constants";

export const splitClient = (customerId) => {
  const split_key = decrypt(REACT_APP_SPLIT_KEY_ENC);
  const factory = SplitFactory({
    core: {
      authorizationKey: split_key, // Replace with your actual key
      key: customerId, // Pass customer-specific key
    }
  });

  return factory.client();
};

export const initSplitAndDispatch = (userId, dispatch) => {
  const user = splitClient(userId);

  user.on(user.Event.SDK_READY, () => {
    const billingTreatment = user.getTreatment("billing");
    const isBillingEnabled = billingTreatment === "on";
    dispatch(setFeatureFlags({ billing: isBillingEnabled }));
  });

  user.on(user.Event.SDK_READY_TIMED_OUT, () => {
    dispatch(setFeatureFlags({ billing: false }));
  });

  return user;
};
